import { render, staticRenderFns } from "./sortByFields.vue?vue&type=template&id=25bfefa0"
import script from "./sortByFields.vue?vue&type=script&lang=js"
export * from "./sortByFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports